module.exports = __webpack_public_path__ + "static/media/14.816c8424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/14.jpg
// module id = 547
// module chunks = 0